import axios from '@/axios.js'
import { apolloClient } from '@/vue-apollo'
import { QuerySerialize } from '@/utils'
import { GET_BUSINESSES, GET_BUSINESS } from '@/store/business/moduleBusinessGraphql'
import { notifyServerError } from '@/layouts/notifies'

export default {
  createBusiness(context, businessData) {
    return new Promise((resolve, reject) => {
      axios
        .post('business', businessData)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  },
  countBusinesses(context) {
    const query = QuerySerialize(context.state.query)
    return new Promise((resolve, reject) => {
      axios
        .get(`business/count/?${query}`)
        .then(response => {
          context.commit('SET_BUSINESSES_COUNT', response.data)
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  },
  fetchBusinesses(context) {
    return new Promise((resolve, reject) => {
      apolloClient
        .query({
          query: GET_BUSINESSES,
          variables: {
            filter: {
              query: context.state.query,
              skip: context.state.skip,
              limit: context.state.limit,
              sort: context.state.sort
            }
          },
          fetchPolicy: 'network-only'
        })
        .then(response => {
          context.commit('SET_BUSINESSES', response.data.businesses)
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  },
  fetchBusinessesRest(context) {
    const query = QuerySerialize(context.state.query)
    const skip = context.state.skip
    const limit = context.state.limit
    return new Promise((resolve, reject) => {
      axios
        .get(`business/?skip=${skip}&limit=${limit}&${query}`)
        .then(response => {
          context.commit('SET_BUSINESSES', response.data)
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  },
  fetchBusinessesWithPlaceState(context, state) {
    const query = QuerySerialize(context.state.query)
    const skip = context.state.skip
    const limit = context.state.limit
    return new Promise((resolve, reject) => {
      axios
        .get(`business/places/${state}?skip=${skip}&limit=${limit}&${query}`)
        .then(response => {
          context.commit('SET_BUSINESSES', response.data)
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  },
  fetchBusiness(context, businessId) {
    return new Promise((resolve, reject) => {
      apolloClient
        .query({
          query: GET_BUSINESS,
          variables: {
            id: businessId
          },
          fetchPolicy: 'network-only'
        })
        .then(response => {
          context.commit('SET_BUSINESSES', response.data.business)
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  },
  removeBusiness(context, businessId) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`business/${businessId}`)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  },
  editBusiness(context, business) {
    return new Promise((resolve, reject) => {
      axios
        .put(`business/${business.id}`, business.data)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  },
  editBusinessState(context, business) {
    return new Promise((resolve, reject) => {
      axios
        .put(`business/${business.id}/state`, { state: business.state })
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  }
}
